var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card" },
    [
      _c("h3", { staticClass: "card-title" }, [
        _vm._v("\n      " + _vm._s(_vm.post.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-detail" }),
      _vm._v(" "),
      _vm.post.thumbnail
        ? _c("img", {
            staticClass: "card-image",
            attrs: { src: _vm.post.thumbnail, alt: _vm.post.title },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card-note" }, [
        _c("p", [_vm._v(_vm._s(_vm.post.summary))]),
      ]),
      _vm._v(" "),
      _c(
        "router-link",
        { attrs: { to: { name: "post", params: { id: _vm.post.id } } } },
        [
          _c(
            "q-link",
            { staticClass: "card-read-more", attrs: { underline: false } },
            [_c("span", [_vm._v(_vm._s(this.$qt("post.card.readMore")))])]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }